/* eslint-disable */ 
import {useState } from "react";
import { Flex, Text, Icon, useColorModeValue, useToast, Link  } from '@chakra-ui/react'; 
import { TbFileInvoice } from 'react-icons/tb';
import { NavLink  as RouterLink } from 'react-router-dom';

// Custom components   

import CommonDatatable from 'components/datatable/CommonDatatable';
import Actions from 'views/privado/servicesPostsales/reclamosLinea/components/Actions';

import service from 'services/reclamosLineaService';

import { 
  createColumnHelper
} from '@tanstack/react-table'
  
type RowObj = {
	wrY56EXREC: number;
    wrY55IMJOB: number;
    wrY55HOJOB: number;
    wrcodexpbu: number;
    wrdgj: string;
    wrdgl: string;
    wrdc: string;
    wralph: string;
    wrY55TIOP: string;
    wrY55NOPRO: string;
    wrY55HATA: string;
    wrY55TIEM: string;
    wrdgL_String: string;
    wrdgJ_String: string;
    wrY56EXREC_String: string;
    wrY55HOJOB_String: string;
    wrY55IMJOB_String: string;
};

import { EXPORT_TITLE, EXPORT_DESCRIPTION, PATH_PRIVADO, PATH_RECLAMOS_LINEA_DETALLE } from "const/CommonConst";

export default function DataTable() {
	const textColor = useColorModeValue("navy.700", "white");

  const toast = useToast()

  const [tableData, setTableData] = useState([]);

  const [showEmptyState, setShowEmptyState] = useState(true);
  const [disabledActions, setDisabledActions] = useState(false);
  const [showProgressSearch, setShowProgressSearch] = useState(false);
  const [showProgressExport, setShowProgressExport] = useState(false);
  

  const fetchData = async (cliente:string) => {
    return await service.getTabla(cliente);
  };

  const onChangeFilters = async (selected:any) => {
	try {
		setShowEmptyState(false);
	setDisabledActions(true);
	setShowProgressSearch(true);
	setTableData(await fetchData(selected.cliente));
}
  finally{
	setDisabledActions(false);
	setShowProgressSearch(false);
  }
  };

  const onExportData = async (selected:any) => {
	try {
	setDisabledActions(true);
	setShowProgressExport(true);
	await service.getExcel(selected.cliente);
	toast({
		title: EXPORT_TITLE,
		description: EXPORT_DESCRIPTION,
		status: 'success',
		duration: 9000,
		isClosable: true,
	  });
	}
	  finally{
		setDisabledActions(false);
		setShowProgressExport(false);
	  }
  };

    const columnHelper = createColumnHelper<RowObj>();
 	const columns = [
		columnHelper.accessor('wrY56EXREC_String', {
			id: 'wrY56EXREC_String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXPEDIENTE RECLAMO
				</Text>
			),
			cell: ({row}) => (
				<Link as={RouterLink}  to={{pathname: `${PATH_PRIVADO}${PATH_RECLAMOS_LINEA_DETALLE.replace(':codigo2',row.original.wrY55IMJOB_String).replace(':codigo1',row.original.wrY55HOJOB_String).replace(':codigo',row.original.wrY56EXREC_String)}`, 
											state: { codigo: row.original.wrY56EXREC_String, codigo1: row.original.wrY55HOJOB_String, codigo2: row.original.wrY55IMJOB_String }}} >
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {row.original.wrY56EXREC_String}
        </Text></Link>
			)
		}), 
		columnHelper.accessor('wrY55IMJOB_String', {
			id: 'wrY55IMJOB_String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXPEDIENTE ADUANA
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('wrY55HOJOB_String', {
			id: 'wrY55HOJOB_String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXPEDIENTE CONSOLIDADO
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
          {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('wrcodexpbu', {
			id: 'wrcodexpbu',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXPEDIENTE NAVIERO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			  </Text>
			)
		}),
		columnHelper.accessor('wrdgL_String', {
			id: 'wrdgL_String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					FECHA RECLAMO
				</Text>
			),
			cell: (info) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('wrdc', {
			id: 'wrdc',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        OFICINA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('wralph', {
			id: 'wralph',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        CLIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('wrY55TIOP', {
			id: 'wrY55TIOP',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        TIPO OPERACION
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('wrY55TIEM', {
			id: 'wrY55TIEM',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        EMBARQUE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		})   
	];
	
  return ( 
    <CommonDatatable
    columnsDefinition={columns}
    tableData={tableData}	
	showEmptyState={showEmptyState}
	isLoading={disabledActions}
    actionContent={    
        <Actions onChange={onChangeFilters} 
				 onExport={onExportData} 
				 disabledActions={disabledActions} 
				 showProgressExport={showProgressExport} 
				 showProgressSearch={showProgressSearch} /> }
      />        
  )
} 
